import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  BookingItemStatusEnum,
  BookingStatus,
  SortEnum,
  SubscriptionFilterParamsInterface,
  TimeslotStatusEnum,
} from '@sport-activities/sdk';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingTypeEnum } from '~/attendee/enums/booking-type.enum';
import { Subscription } from '~/attendee/model/subscription.model';
import { ACTIVITIES_BASE_URL } from '~/core/core.module';
import { createHttpParams } from '~/core/helpers/create-http-params/create-http-params.helper';
import { SubscriptionInterface } from '../interfaces/subscription.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(ACTIVITIES_BASE_URL) private readonly activitiesUrl: string
  ) {}

  public getSubscriptions(type: BookingTypeEnum): Observable<Subscription[]> {
    const today = new Date().toISOString();
    const filters: SubscriptionFilterParamsInterface = {
      sort: {
        order: 'desc' as SortEnum,
        by: 'timeslots.startDate',
      },
    };

    if (type === BookingTypeEnum.WAITING) {
      filters.startDate = today;
      filters.bookingStatus = 'VALIDATED' as BookingStatus;
      filters.timeslotStatus = 'PUBLISHED' as TimeslotStatusEnum;
      filters.bookingItemStatus = 'VALIDATED' as BookingItemStatusEnum;
    }

    if (type === BookingTypeEnum.UPCOMING) {
      filters.endAfterDate = today;
      filters.bookingStatus = 'COMPLETED' as BookingStatus;
      filters.timeslotStatus = 'PUBLISHED' as TimeslotStatusEnum;
      filters.bookingItemStatus = 'COMPLETED' as BookingItemStatusEnum;
    }

    if (type === BookingTypeEnum.PAST) {
      filters.endDate = today;
      filters.bookingItemStatus = 'COMPLETED' as BookingItemStatusEnum;
      filters.bookingStatus = 'COMPLETED' as BookingStatus;
    }

    if (type === BookingTypeEnum.CANCELED) {
      filters.bookingItemStatus = 'CANCELED' as BookingItemStatusEnum;
      filters.bookingStatus = 'COMPLETED' as BookingStatus;
    }

    return this.httpClient
      .get<SubscriptionInterface[]>(`${this.activitiesUrl}/me/subscriptions`, {
        params: createHttpParams(filters),
      })
      .pipe(
        map((subscriptions) =>
          subscriptions.map((subscription) => new Subscription(subscription))
        )
      );
  }
}
